export default __webpack_public_path__ + "assets/images/search-form-background_2lGrB.jpg";